import axios from 'axios';
import * as Constants from "../constants";

const PREVIEW_API_URL = Constants.API_URL + 'v2/preview/';

class PreviewService {
    create(country_code) {
        function getCookie(cname) {
            const name = cname + "=";
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
        const bidQueryParam= new URLSearchParams(window.location.search).get('bid');
        const bidCookie = getCookie('adcell').split('#')[0];
        let data = {
            "country": country_code,
            "adsinfo": bidCookie || bidQueryParam
        };

        return axios.post(PREVIEW_API_URL + 'create', data)
            .then(response => {
                return response.data;
            });
    }

    update(data) {
        return axios.post(PREVIEW_API_URL + 'update', data)
            .then(response => {
                return response.data
            });
    }

    finish(data) {
        return axios.post(PREVIEW_API_URL + 'finish', data)
            .then(response => {
                return response.data
            });
    }
}

export default new PreviewService();
